/* eslint-disable i18n-scan/no-inline-content */
/* eslint-disable complexity */
import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useMessage } from '../../hooks'

const DocumentHeaders = ({ pathname }) => {
  const [title, setTitle] = useState('')
  const localizedMsg = useMessage()
  useEffect(() => {
    if (pathname) {
      if (pathname === '/applications/sandbox') {
        setTitle(localizedMsg('applications.headerTitle'))
      } else if (pathname.includes('/applications/edit/')) {
        setTitle(localizedMsg('applications-details-edit.headerTitle'))
      } else if (pathname === '/applications/createbtcred') {
        setTitle(localizedMsg('createbtcred.headerTitle'))
      } else if (pathname === '/applications/live/create') {
        setTitle(localizedMsg('applications-create-app.headerTitle'))
      } else if (pathname === '/applications/braintreeCredentials/editbtcred') {
        setTitle(localizedMsg('editbtcred.headerTitle'))
      } else if (pathname === '/accountStatus') {
        setTitle(localizedMsg('account.headerTitle'))
      } else if (
        pathname === '/accounts' ||
        pathname === '/accounts/edit/' ||
        pathname === '/accounts/create' ||
        pathname === '/accounts/bulk' ||
        pathname === '/accounts/create/custom' ||
        pathname.includes('/accounts/duplicate/')
      ) {
        setTitle(localizedMsg('sandbox-account.headerTitle'))
      } else if (pathname === '/notifications') {
        setTitle(localizedMsg('notifications.headerTitle'))
      } else if (pathname === '/dashboard/sandbox') {
        setTitle(localizedMsg('dashboard.sandbox.headerTitle'))
      } else if (pathname === '/dashboard/live') {
        setTitle(localizedMsg('dashboard.live.headerTitle'))
      } else if (pathname === '/creditCardGenerator') {
        setTitle(localizedMsg('mock.ccgenerator.headerTitle'))
      } else if (pathname === '/ipnSimulator') {
        setTitle(localizedMsg('ipn.ipnSimulator.title'))
      } else if (pathname === '/webhooksSimulator') {
        setTitle(localizedMsg('mock.whsimulator.headerTitle'))
      } else if (pathname === '/webhooks/live') {
        setTitle(localizedMsg('webhooksevents.live.headerTitle'))
      } else if (pathname === '/webhooks/sandbox') {
        setTitle(localizedMsg('webhooksevents.header.sandboxHeaderTitle'))
      }
    }
  }, [pathname])

  return (
    <Helmet htmlAttributes={{ lang: 'en' }}>
      <title>{`${title}`}</title>
      <link
        rel="icon"
        sizes="32x32"
        href="https://www.paypalobjects.com/webstatic/developer/favicons/pp32.png"
      />
      <meta
        name="description"
        content="Developer Dashboard for apps and tools"
      />
      <meta name="keywords" content="Developer, Dashboard, apps, tools" />
    </Helmet>
  )
}

export default DocumentHeaders
